




































































































































































































































































































































import {
  computed,
  defineComponent, PropType, Ref, ref, watch,
} from 'vue';
import { EdgesSpec, TableRow } from 'multinet';
import WorkspaceOptionMenu from '@/components/WorkspaceOptionMenu.vue';

import api from '@/api';
import { App } from '@/types';

export default defineComponent({
  name: 'NetworkDetail',

  components: {
    WorkspaceOptionMenu,
  },

  props: {
    workspace: {
      type: String as PropType<string>,
      required: true,
    },
    network: {
      type: String as PropType<string>,
      required: true,
    },
    apps: {
      type: Object as PropType<{ network_visualizations: App[]; table_visualizations: App[] }>,
      required: true,
    },
  },
  setup(props) {
    const nodeTypes: Ref<string[]> = ref([]);
    const edgeTypes: Ref<string[]> = ref([]);
    const nodes: Ref<string[]> = ref([]);
    const offset = ref(0);
    const limit = ref(10);
    const loading = ref(true);
    const totalNodes = ref(0);
    const totalEdges = ref(0);
    const visItems = ref(['Network Overview']);
    const selectedVis = ref(visItems.value[0]);
    const panelOpen = ref(true);

    const highestOffset = computed(() => (totalNodes.value % limit.value
      ? Math.floor(totalNodes.value / limit.value)
      : totalNodes.value / limit.value - 1
    ) * limit.value);
    const next = computed(() => highestOffset.value !== offset.value);
    const prev = computed(() => offset.value !== 0);
    const nodeColsClasses = computed(() => `d-flex flex-row node-cols${panelOpen.value ? '' : ' node-cols-closed'}`);
    const networkVisClasses = computed(() => `network-vis${panelOpen.value ? '' : ' network-vis-closed'}`);
    const drawerIcon = computed(() => (panelOpen.value ? 'mdi-chevron-down' : 'mdi-chevron-up'));

    function toggle() {
      panelOpen.value = !panelOpen.value;
    }
    async function update() {
      function tableName(tableRow: TableRow | EdgesSpec) {
        // eslint-disable-next-line no-underscore-dangle
        return tableRow._id.split('/')[0];
      }
      loading.value = true;
      const network = await api.network(props.workspace, props.network);
      const newNodes = await api.nodes(props.workspace, props.network, {
        offset: offset.value,
        limit: limit.value,
      });
      const newEdges = await api.edges(props.workspace, props.network, {
        offset: offset.value,
        limit: limit.value,
      });
      totalNodes.value = network.node_count;
      totalEdges.value = network.edge_count;

      const prelimNodes = newNodes.results.map((node) => tableName(node));
      prelimNodes.forEach((nodeType) => {
        if (!nodeTypes.value.includes(nodeType)) {
          nodeTypes.value.push(nodeType);
        }
      });
      edgeTypes.value = newEdges.results.length > 0 ? [tableName(newEdges.results[0])] : [];
      nodeTypes.value = nodeTypes.value.sort();
      edgeTypes.value = edgeTypes.value.sort();

      // eslint-disable-next-line no-underscore-dangle
      nodes.value = newNodes.results.map((node) => node._id);
      loading.value = false;
    }
    function turnPage(forward: number) {
      offset.value += forward ? limit.value : -limit.value;
    }
    function lastPage() {
      offset.value = highestOffset.value;
    }
    function firstPage() {
      offset.value = 0;
    }

    watch([offset, limit, () => props.workspace, () => props.network], () => update());

    update();

    return {
      nodeTypes,
      edgeTypes,
      nodes,
      offset,
      limit,
      loading,
      totalNodes,
      totalEdges,
      visItems,
      selectedVis,
      panelOpen,
      toggle,
      drawerIcon,
      next,
      prev,
      nodeColsClasses,
      networkVisClasses,
      turnPage,
      lastPage,
      firstPage,
    };
  },
});
